import { getUserFirstComment } from "../services/UserService";

/**
 * Returns the share text for a property.
 * If the user has a first-level comment, use it; otherwise, use the address.
 * @param {Object} params
 * @param {string} params.userId
 * @param {Object} params.property
 * @returns {Promise<string>}
 */
export async function getShareTextForProperty({ userId, property }) {
    let shareTextBody = property?.full_address;
    try {
        if (userId && property?.id) {
            const firstCommentRes = await getUserFirstComment(userId, "Property", property.id);
            const commentContent = firstCommentRes?.comment?.content;
            if (typeof commentContent === "string" && commentContent.trim().length > 0) {
                shareTextBody = commentContent.trim();
            }
        }
    } catch (e) {
        // fallback to address if error
        shareTextBody = property?.full_address;
    }
    return shareTextBody;
}
